import {
  FormattedString,
  InfoBlock,
  InfoBlockLayout,
  InfoBlockStatus,
  InputFormCallout,
  InputFormCalloutProps,
} from "o4a-react";
import * as React from "react";
import * as Messages from "../../codegen/Messages";
import { maxExaInfraStorageServerCount, minExaInfraStorageServerCount } from "../../helpers/resourceHelper";
import { useFeatures } from "../../hooks/useFeatures";
import { IntegerInput } from "../IntegerInput/IntegerInput";

export const enum Fields {
  ComputeCount = "computeCount",
  StorageCount = "storageCount"
}

export interface ExaInfraScaleConfig {
  computeCount: number | undefined;
  storageCount: number | undefined;
  minimumNodeCount: number | undefined;
  maximumNodeCount: number | undefined;
}

export interface ExadataInfraScalePanelProps extends
  Omit<InputFormCalloutProps, "children" | "layout" | "submitButtonMode" | "defaultButtonText">
{
  exaInfraScaleConfig: ExaInfraScaleConfig;
}

export const ExadataInfraScalePanel = ({
  exaInfraScaleConfig: {
    computeCount,
    storageCount,
    maximumNodeCount,
    minimumNodeCount,
  },
  title,
  onClose,
  onSubmit,
  targetId,
  primaryButtonText,
  componentRef,
}: ExadataInfraScalePanelProps): JSX.Element => {
  const { enableAddVMCapacity } = useFeatures();
  return (
    <InputFormCallout
      componentRef={componentRef}
      title={title || ""}
      targetId={targetId}
      onClose={onClose}
      onSubmit={onSubmit}
      primaryButtonText={primaryButtonText}
    >
      <>
        <IntegerInput
          fieldName={Fields.ComputeCount}
          label={Messages.labels.databaseServers()}
          min={computeCount || minimumNodeCount}
          max={maximumNodeCount}
          defaultValue={computeCount}
          required
        />
        <IntegerInput
          fieldName={Fields.StorageCount}
          label={Messages.labels.storageServers()}
          min={computeCount || minExaInfraStorageServerCount}
          max={maxExaInfraStorageServerCount}
          defaultValue={storageCount}
          required
        />
      </>
      {enableAddVMCapacity && (
      <InfoBlock
        message={(FormattedString({ inputText: Messages.hints.scaleExaInfra() }) as unknown as string)}
        messageType={InfoBlockStatus.INFO}
        infoLayout={InfoBlockLayout.Compact}
        customInfoStyle={{ root: { marginBottom: "15px" } }}
      />
      )}
    </InputFormCallout>
  );
};
